/* tslint:disable */
/* eslint-disable */
/**
 * FancyAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GetActivityFeedForStudentR200ResponseInnerScoreFromJSON, GetActivityFeedForStudentR200ResponseInnerScoreToJSON, } from './GetActivityFeedForStudentR200ResponseInnerScore';
/**
 * @export
 */
export const GetActivityFeedForStudentR200ResponseInnerProductEnum = {
    MathDiagnostic: 'math-diagnostic',
    ElaWordStudyDiagnostic: 'ela-word-study-diagnostic',
    ElaDiagnostic: 'ela-diagnostic',
    ElaReadingFiction: 'ela-reading-fiction',
    ElaReadingNonFiction: 'ela-reading-non-fiction',
    ElaAssessments: 'ela-assessments',
    ElaReading: 'ela-reading',
    ElaWordStudy: 'ela-word-study',
    ElaWriting: 'ela-writing',
    ElaAdaptiveSkills: 'ela-adaptive-skills',
    ElaTargetedSkills: 'ela-targeted-skills',
    ElaFocusSkillsPractice: 'ela-focus-skills-practice',
    ElaSightWords: 'ela-sight-words',
    ElaDecodables: 'ela-decodables',
    MathAdaptivePractice: 'math-adaptive-practice',
    MathAssessments: 'math-assessments',
    MathFactPractice: 'math-fact-practice',
    MathInquiryBasedLessons: 'math-inquiry-based-lessons',
    MathTargetedPractice: 'math-targeted-practice',
    MathFocusSkillsPractice: 'math-focus-skills-practice',
    MathNumberFacts: 'math-number-facts',
    MathNumberBasics: 'math-number-basics',
    MathTargetedDepthOfKnowledgePractice: 'math-targeted-depth-of-knowledge-practice',
    MathAdaptiveDepthOfKnowledgePractice: 'math-adaptive-depth-of-knowledge-practice',
    SocialStudiesReading: 'social-studies-reading',
    SocialStudiesWriting: 'social-studies-writing',
    ScienceReading: 'science-reading',
    ScienceWriting: 'science-writing'
};
/**
 * Check if a given object implements the GetActivityFeedForStudentR200ResponseInner interface.
 */
export function instanceOfGetActivityFeedForStudentR200ResponseInner(value) {
    if (!('product' in value) || value['product'] === undefined)
        return false;
    if (!('sessionId' in value) || value['sessionId'] === undefined)
        return false;
    if (!('studentId' in value) || value['studentId'] === undefined)
        return false;
    if (!('timeCompleted' in value) || value['timeCompleted'] === undefined)
        return false;
    return true;
}
export function GetActivityFeedForStudentR200ResponseInnerFromJSON(json) {
    return GetActivityFeedForStudentR200ResponseInnerFromJSONTyped(json, false);
}
export function GetActivityFeedForStudentR200ResponseInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'assignmentId': json['assignmentId'] == null ? undefined : json['assignmentId'],
        'contentLevel': json['contentLevel'] == null ? undefined : json['contentLevel'],
        'gradeLevel': json['gradeLevel'] == null ? undefined : json['gradeLevel'],
        'mathSubSkillPracticed': json['mathSubSkillPracticed'] == null ? undefined : json['mathSubSkillPracticed'],
        'minutesPracticed': json['minutesPracticed'] == null ? undefined : json['minutesPracticed'],
        'numberCorrect': json['numberCorrect'] == null ? undefined : json['numberCorrect'],
        'numberQuestions': json['numberQuestions'] == null ? undefined : json['numberQuestions'],
        'prerequisiteAssignment': json['prerequisiteAssignment'] == null ? undefined : json['prerequisiteAssignment'],
        'product': json['product'],
        'score': json['score'] == null ? undefined : GetActivityFeedForStudentR200ResponseInnerScoreFromJSON(json['score']),
        'sessionId': json['sessionId'],
        'studentId': json['studentId'],
        'timeCompleted': (new Date(json['timeCompleted'])),
        'topic': json['topic'] == null ? undefined : json['topic'],
        'worth': json['worth'] == null ? undefined : json['worth'],
    };
}
export function GetActivityFeedForStudentR200ResponseInnerToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'assignmentId': value['assignmentId'],
        'contentLevel': value['contentLevel'],
        'gradeLevel': value['gradeLevel'],
        'mathSubSkillPracticed': value['mathSubSkillPracticed'],
        'minutesPracticed': value['minutesPracticed'],
        'numberCorrect': value['numberCorrect'],
        'numberQuestions': value['numberQuestions'],
        'prerequisiteAssignment': value['prerequisiteAssignment'],
        'product': value['product'],
        'score': GetActivityFeedForStudentR200ResponseInnerScoreToJSON(value['score']),
        'sessionId': value['sessionId'],
        'studentId': value['studentId'],
        'timeCompleted': ((value['timeCompleted']).toISOString()),
        'topic': value['topic'],
        'worth': value['worth'],
    };
}
